const PATHS = {
  7:   '/sounds/chime_m7_7days.wav',
  30:  '/sounds/chime_m30_30days.wav',
  100: '/sounds/chime_m100_100days.wav',
  365: '/sounds/chime_m365_365days.wav',
};

export function playMilestoneChime(streakCount) {
  try {
    const path = PATHS[streakCount];
    if (!path) return;
    const audio = new Audio(path);
    audio.play().catch(() => {});
  } catch { /* browser may block autoplay */ }
}
